<script setup>
// auth store
import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

</script>

<template>
	<SectionCard title="App Documentation">
		<Heading size="2">Viewing Invoices</Heading>
		<Alert type="info" class="text-sm" v-if="!auth.can('view_invoices')"><b>Note:</b> Only users with the "View Invoices" permissions are able to view invoices on behalf of their organisation. <b>You do not have this permission on your account.</b> You'll need to ask your organisation head for the proper access.</Alert>

		<br />

		<div v-if="auth.isAdmin">
			<p>As an admin you can view invoices for any organisation. To do this, navigate to the organisation in question and scroll down to see the list of invoices.</p>
		</div>

		<div v-else>
			<p>In order to view invoices for your organisation, click on the "Invoices" link in the site navigation on the left. You will be taken to a page with a list of invoices relevant to your organisation. From here you can download a PDF of the invoice or make a manual payment by using the buttons to the right of the relevant invoice in the table:</p>
		</div>

		<img src="/images/docs/invoices-list.png" class="w-full p-8" />

		<Alert type="info" class="text-sm">
			<b>Note:</b> You can filter invoices by status by using the filter feature on the table. Hover your mouse over the "Status" table heading and click the three line icon that appears. Then enter your desired status into the "Filter" text input. Common statuses are "PAID" for invoices that have already been paid, "VOID" for voided invoices and "AUTHORISED" for invoices that are awaiting payment:
			<img src="/images/docs/invoices-filter.png" class="w-full p-8" />
		</Alert>


	</SectionCard>
</template>